import { CandleBreakTacticPanel } from '../individualTacticPanels/entries/CandleBreakTacticPanel';
import { LimitOrderTacticPanel } from '../individualTacticPanels/entries/LimitOrderTacticPanel';
import { MarketOrderTacticPanel } from '../individualTacticPanels/entries/MarketOrderTacticPanel';
import { AtrTrailTacticPanel } from '../individualTacticPanels/exits/AtrTrailTacticPanel';
import { BreakPriceTacticPanel } from '../individualTacticPanels/exits/BreakPriceTacticPanel';
import { CandleMagnitudeTacticPanel } from '../individualTacticPanels/exits/candleMagnitude/CandleMagnitudeTacticPanel';
import { CandleTrailTacticPanel } from '../individualTacticPanels/exits/CandleTrailTacticPanel';
import { GrabCentsTacticPanel } from '../individualTacticPanels/exits/GrabCentsTacticPanel';
import { GreenToRedCandlesTacticPanel } from '../individualTacticPanels/exits/GreenToRedCandlesTacticPanel';
import { GreenToRedPositionsTacticPanel } from '../individualTacticPanels/exits/GreenToRedPositionsTacticPanel';
import { LossLimitTacticPanel } from '../individualTacticPanels/exits/LossLimitTacticPanel';
import { MfeRetracementTacticPanel } from '../individualTacticPanels/exits/MfeRetracementTacticPanel';
import { PositionBreakPriceTacticPanel } from '../individualTacticPanels/exits/PositionBreakPriceTacticPanel';
import { PositionPriceTrailTacticPanel } from '../individualTacticPanels/exits/PositionPriceTrailTacticPanel';
import { PreserveProfitTacticPanel } from '../individualTacticPanels/exits/PreserveProfitTacticPanel';
import { RatchetBracketTacticPanel } from '../individualTacticPanels/exits/RatchetBracketTacticPanel';
import { UnderlyingPriceExitTacticPanel } from '../individualTacticPanels/exits/underlyingPriceExit/UnderlyingPriceExitTacticPanel';
import { UnderlyingPriceTrailTacticPanel } from '../individualTacticPanels/exits/UnderlyingPriceTrailTacticPanel';
import { AddToWinnerTacticPanel } from '../individualTacticPanels/positions/addToWinner/AddToWinnerTacticPanel';
import { ScalingInTacticPanel } from '../individualTacticPanels/positions/scalingIn/ScalingInTacticPanel';
import { EmaIntersectsFirstCandleTacticPanel } from '../individualTacticPanels/setupFilters/EmaIntersectsFirstCandleTacticPanel';
import { FtfcTacticPanel } from '../individualTacticPanels/setupFilters/ftfc/FtfcTacticPanel';
import { PriceIntersectsFirstCandleTacticPanel } from '../individualTacticPanels/setupFilters/PriceIntersectsFirstCandleTacticPanel';
import { TimeOfDayTacticPanel } from '../individualTacticPanels/setupFilters/TimeOfDayTacticPanel';
import { BounceEmaTacticPanel } from '../individualTacticPanels/setups/BounceEmaTacticPanel';
import { BounceTacticPanel } from '../individualTacticPanels/setups/BounceTacticPanel';
import { BreakCandleTypeTacticPanel } from '../individualTacticPanels/setups/BreakCandleTypeTacticPanel';
import { BreakEmaTacticPanel } from '../individualTacticPanels/setups/BreakEmaTacticPanel';
import { BreakTacticPanel } from '../individualTacticPanels/setups/BreakTacticPanel';
import { CandlePatternTacticPanel } from '../individualTacticPanels/setups/candlePattern/CandlePatternTacticPanel';
import { CandleTriggerTacticPanel } from '../individualTacticPanels/setups/CandleTriggerTacticPanel';
import { ConvictionCandleTacticPanel } from '../individualTacticPanels/setups/ConvictionCandleTacticPanel';
import { FlagTacticPanel } from '../individualTacticPanels/setups/FlagTacticPanel';
import { OrbTacticPanel } from '../individualTacticPanels/setups/OrbTacticPanel';
import { OptionConfigurationPanel } from '../panels/optionConfigurationPanel/OptionConfigurationPanel';
import { OverviewPanel } from '../panels/overviewPanel/OverviewPanel';
import { SettingsPanel } from '../panels/settingsPanel/SettingsPanel';
import { AddTacticPanel } from '../panels/tacticsPanel/addTacticPanel/AddTacticPanel';
import { AddAtrTrailTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddAtrTrailTacticPanel';
import { AddCandleMagnitudeTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddCandleMagnitudeTacticPanel';
import { AddCandleTrailTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddCandleTrailTacticPanel';
import { AddGreenToRedCandlesTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddGreenToRedCandlesTacticPanel';
import { AddGreenToRedPositionsTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddGreenToRedPositionsTacticPanel';
import { AddLossLimitTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddLossLimitTacticPanel';
import { AddMfeRetracementTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddMfeRetracementTacticPanel';
import { AddPositionPriceTrailTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPositionPriceTrail';
import { AddPreserveProfitTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPreserveProfitTacticPanel';
import { AddRatchetBracketTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddRatchetBracketTacticPanel';
import { AddUnderlyingPriceExitTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddUnderlyingPriceExitTacticPanel';
import { AddUnderlyingPriceTrailTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddUnderlyingPriceTrailTacticPanel';
import { AddPositionBreakPriceTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPositionBreakPriceTacticPanel';
import { AddBreakPriceTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/breakPrice/AddBreakPriceTacticPanel';
import { AddGrabCentsTacticPanel } from '../panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/grabCents/AddGrabCentsTacticPanel';
import { TacticsPanel } from '../panels/tacticsPanel/TacticsPanel';

export const labelMap = {
  tactics: 'Tactics',
  overview: 'Overview',
  optionConfig: 'Option Config',
  settings: 'Settings',
  //setups
  BREAK: 'Break',
  BOUNCE: 'Bounce',
  CONVICTION_CANDLE: 'Conviction Candle',
  CANDLE_TRIGGER: 'Candle Trigger',
  BREAK_CANDLE_TYPE: 'Break Candle Type',
  ORB: 'ORB',
  BOUNCE_EMA: 'Bounce EMA',
  BREAK_EMA: 'Break EMA',
  CANDLE_PATTERN: 'Candle Pattern',
  FLAG: 'Flag',

  //setupFilters
  PRICE_INTERSECTS_FIRST_CANDLE: 'Price Intersects',
  EMA_INTERSECTS_FIRST_CANDLE: 'EMA Intersects',
  TIME_OF_DAY: 'Time Of Day',
  FTFC: 'FTFC',

  //entries
  MARKET_ORDER: 'Market Order',
  LIMIT_ORDER: 'Limit Order',
  CANDLE_BREAK: 'Candle Break',

  //position
  ADD_TO_WINNER: 'Add to Winner',
  SCALING_IN: 'Scaling In',

  //exits
  BREAK_PRICE: 'Underlying Break Price',
  CANDLE_TRAIL: 'Candle Trail',
  GRAB_CENTS: 'Grab Cents',
  GREEN_TO_RED_CANDLES: 'G2R Candles',
  GREEN_TO_RED_POSITIONS: 'G2R Positions',
  LOSS_LIMIT: 'Loss Limit',
  POSITION_PRICE_TRAIL: 'Position Price Trail',
  PRESERVE_PROFIT: 'Preserve Profit',
  RATCHET_BRACKET: 'Ratchet Bracket',
  CANDLE_MAGNITUDE: 'Candle Magnitude',
  UNDERLYING_PRICE_TRAIL: 'Underlying Price Trail',
  ATR_TRAIL: 'ATR Trail',
  MFE_RETRACEMENT: 'MFE Retracement',
  UNDERLYING_PRICE_EXIT: 'Underlying Price Exit',
  POSITION_BREAK_PRICE: 'Position Break Price',

  //add tactic
  ADD_TACTIC: 'Add Tactic',
  ADD_BREAK_PRICE: 'Add Break Price',
  ADD_CANDLE_TRAIL: 'Add Candle Trail',
  ADD_GRAB_CENTS: 'Add Grab Cents',
  ADD_GREEN_TO_RED_CANDLES: 'Add G2R Candles',
  ADD_GREEN_TO_RED_POSITIONS: 'Add G2R Positions',
  ADD_LOSS_LIMIT: 'Add Loss Limit',
  ADD_POSITION_PRICE_TRAIL: 'Add Position Price Trail',
  ADD_PRESERVE_PROFIT: 'Add Preserve Profit',
  ADD_RATCHET_BRACKET: 'Add Ratchet Bracket',
  ADD_CANDLE_MAGNITUDE: 'Add Candle Magnitude',
  ADD_UNDERLYING_PRICE_TRAIL: 'Add Underlying Price Trail',
  ADD_ATR_TRAIL: 'Add ATR Trail',
  ADD_MFE_RETRACEMENT: 'Add MFE Retracement',
  ADD_UNDERLYING_PRICE_EXIT: 'Add Underlying Price Exit',
  ADD_POSITION_BREAK_PRICE: 'Add Position Break Price'
};

export const panelMap = {
  tactics: TacticsPanel,
  optionConfig: OptionConfigurationPanel,
  overview: OverviewPanel,
  settings: SettingsPanel,

  //setups
  BREAK: BreakTacticPanel, //
  BOUNCE: BounceTacticPanel, //
  CONVICTION_CANDLE: ConvictionCandleTacticPanel, // right color checkbox not working, maybe BE
  CANDLE_TRIGGER: CandleTriggerTacticPanel, //
  BREAK_CANDLE_TYPE: BreakCandleTypeTacticPanel, //
  ORB: OrbTacticPanel, //
  BOUNCE_EMA: BounceEmaTacticPanel, //
  BREAK_EMA: BreakEmaTacticPanel, //
  CANDLE_PATTERN: CandlePatternTacticPanel, //
  FLAG: FlagTacticPanel, //

  //setupFilters
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandleTacticPanel, //
  EMA_INTERSECTS_FIRST_CANDLE: EmaIntersectsFirstCandleTacticPanel, //
  TIME_OF_DAY: TimeOfDayTacticPanel, //
  FTFC: FtfcTacticPanel, //

  //entries
  MARKET_ORDER: MarketOrderTacticPanel, //
  LIMIT_ORDER: LimitOrderTacticPanel, //
  CANDLE_BREAK: CandleBreakTacticPanel, //

  //position
  ADD_TO_WINNER: AddToWinnerTacticPanel, //
  SCALING_IN: ScalingInTacticPanel, //

  //exits
  BREAK_PRICE: BreakPriceTacticPanel, //
  CANDLE_TRAIL: CandleTrailTacticPanel, //
  GRAB_CENTS: GrabCentsTacticPanel, //
  GREEN_TO_RED_CANDLES: GreenToRedCandlesTacticPanel, //
  GREEN_TO_RED_POSITIONS: GreenToRedPositionsTacticPanel, //
  LOSS_LIMIT: LossLimitTacticPanel, //
  POSITION_PRICE_TRAIL: PositionPriceTrailTacticPanel, //
  PRESERVE_PROFIT: PreserveProfitTacticPanel, //
  RATCHET_BRACKET: RatchetBracketTacticPanel, //
  CANDLE_MAGNITUDE: CandleMagnitudeTacticPanel, // 
  UNDERLYING_PRICE_TRAIL: UnderlyingPriceTrailTacticPanel, //
  ATR_TRAIL: AtrTrailTacticPanel,
  MFE_RETRACEMENT: MfeRetracementTacticPanel,
  UNDERLYING_PRICE_EXIT: UnderlyingPriceExitTacticPanel,
  POSITION_BREAK_PRICE: PositionBreakPriceTacticPanel,

  //add tactic
  ADD_TACTIC: AddTacticPanel,
  ADD_BREAK_PRICE: AddBreakPriceTacticPanel, // 
  ADD_CANDLE_TRAIL: AddCandleTrailTacticPanel, // 
  ADD_GRAB_CENTS: AddGrabCentsTacticPanel, // 
  ADD_GREEN_TO_RED_CANDLES: AddGreenToRedCandlesTacticPanel, // 
  ADD_GREEN_TO_RED_POSITIONS: AddGreenToRedPositionsTacticPanel, // 
  ADD_LOSS_LIMIT: AddLossLimitTacticPanel, // 
  ADD_POSITION_PRICE_TRAIL: AddPositionPriceTrailTacticPanel, // 
  ADD_PRESERVE_PROFIT: AddPreserveProfitTacticPanel, // 
  ADD_RATCHET_BRACKET: AddRatchetBracketTacticPanel, // 
  ADD_CANDLE_MAGNITUDE: AddCandleMagnitudeTacticPanel, // 
  ADD_UNDERLYING_PRICE_TRAIL: AddUnderlyingPriceTrailTacticPanel, // 
  ADD_ATR_TRAIL: AddAtrTrailTacticPanel,
  ADD_MFE_RETRACEMENT: AddMfeRetracementTacticPanel,
  ADD_UNDERLYING_PRICE_EXIT: AddUnderlyingPriceExitTacticPanel,
  ADD_POSITION_BREAK_PRICE: AddPositionBreakPriceTacticPanel,
};

export const domainMap = {
  tactics: 'Tactics',
  //setups
  BREAK: 'Underlying',
  BOUNCE: 'Underlying',
  CONVICTION_CANDLE: 'Underlying',
  CANDLE_TRIGGER: 'Underlying',
  BREAK_CANDLE_TYPE: 'Underlying',
  ORB: 'Underlying',
  BOUNCE_EMA: 'Underlying',
  BREAK_EMA: 'Underlying',
  CANDLE_PATTERN: 'Underlying',
  FLAG: 'Underlying',

  //setupFilters
  PRICE_INTERSECTS_FIRST_CANDLE: 'Underlying',
  EMA_INTERSECTS_FIRST_CANDLE: 'Underlying',
  TIME_OF_DAY: 'Time',
  FTFC_FILTER: 'Time',

  //entries
  MARKET_ORDER: 'Underlying',
  LIMIT_ORDER: 'Underlying',
  CANDLE_BREAK: 'Underlying',

  //position
  ADD_TO_WINNER: 'Profit/Loss',
  SCALING_IN: 'Profit/Loss',

  //exits
  BREAK_PRICE: 'Underlying',
  CANDLE_TRAIL: 'Underlying',
  GRAB_CENTS: 'Profit/Loss',
  GREEN_TO_RED_CANDLES: 'Underlying',
  GREEN_TO_RED_POSITIONS: 'Underlying',
  LOSS_LIMIT: 'Profit/Loss',
  POSITION_PRICE_TRAIL: 'Underlying',
  PRESERVE_PROFIT: 'Profit/Loss',
  RATCHET_BRACKET: 'Underlying',
  CANDLE_MAGNITUDE: 'Underlying',
  UNDERLYING_PRICE_EXIT: 'Underlying',
  POSITION_BREAK_PRICE: 'Option Price',
};
